import { client } from '../../lib/urql';

import { GET_APP_CONFIG_QUERY } from '../../../graphql/space/getAppConfigData.query';
import { UPDATE_APP_CONFIG_QUERY } from '../../../graphql/space/updateAppConfig.query';

export const getAppConfigData = async (blockId: string): Promise<any> => {
  const response = await client.query({
    query: GET_APP_CONFIG_QUERY,
    variables: { blockId },
    fetchPolicy: 'no-cache',
  });

  return response.data;
};

export const updateAppConfig = async (updateAppConfigInput: {
  blockId: string;
  config: string;
}): Promise<any> => {
  const response = await client.mutate({
    mutation: UPDATE_APP_CONFIG_QUERY,
    variables: { updateAppConfigInput },
  });

  return response.data;
};
